import React from 'react';

// Components
import { CallNotifications } from '../modules/call-notifications/call-notifications';

// Styles
import './status-unavailable.scss';

export const StatusUnavailable = () => {

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${workerId}`;

  return (<CallNotifications
    title={'Availability Issue'}
    text={'The Consultant is not available at the moment. You may try to contact them later. The payment for the Consultation will be refunded to you.'}
    navigateAction={returnPathname}  />);
}
